import {
    ChangeDetectionStrategy,
    Component,
    Input,
    Output,
    ViewEncapsulation,
    EventEmitter,
    OnChanges, SimpleChanges, OnInit
} from '@angular/core';
import { UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { BaseComponent } from '../../base.component';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-counter-input-field',
    templateUrl: './counter-input-field.component.html',
    styleUrls: ['./counter-input-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [MatFormFieldModule, MatButtonModule, MatInputModule, FormsModule, ReactiveFormsModule]
})
export class CounterInputFieldComponent extends BaseComponent implements OnInit, OnChanges {
    @Input() min: number;
    @Input() max: number;
    @Input() counter: number;
    @Input() id: string;

    @Output() changed = new EventEmitter<number>();

    counterForm: UntypedFormControl = new UntypedFormControl(1);

    ngOnInit() {
        this.counterForm.setValidators([Validators.min(this.min), Validators.max(this.max)]);
        this.subscribeCounterValueChanges();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.counter) {
            this.counterForm.setValue(this.counter);
        }
    }

    setCounter(counter: number) {
        if (this.min <= counter && (!this.max || counter <= this.max)) {
            this.counterForm.setValue(counter);
        }
    }

    private subscribeCounterValueChanges() {
        this.counterForm.valueChanges
            .pipe(
                distinctUntilChanged(),
                debounceTime(500),
                takeUntil(this.destroyed$))
            .subscribe((counter: number) => {
                if (this.min <= counter && (!this.max || counter <= this.max)) {
                    this.changed.emit(counter);
                }
            })
    }
}
